import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import {MatFormField} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {TranslateModule} from "@ngx-translate/core";
import {
  COUNTRIES_DB,
  COUNTRIES_DB_FR,
  Country,
} from "select-country-angular-20";

@Component({
  selector: "app-country-select",
  templateUrl: "./country-select.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormField, MatSelect, MatOption, TranslateModule],
})
export class CountrySelectComponent implements OnChanges {
  @Input() value = "";
  @Input() language = "en";
  @Input() required = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();

  public countries: Country[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["language"] || this.countries.length === 0) {
      const language = this.language === "fr" ? "fr" : "en";
      const countries = language === "fr" ? COUNTRIES_DB_FR : COUNTRIES_DB;
      this.countries = [...countries].sort((left, right) =>
        (left.name ?? left.alpha2Code).localeCompare(
          right.name ?? right.alpha2Code,
          language
        )
      );
    }
  }
}
